import { graphql } from 'react-apollo';
import compose from 'lodash.flowright';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import WebGalleryAlbum from './WebGalleryAlbum';
import {
  AlbumForWebGalleries,
  AlbumForWebGalleriesPhotos,
  AlbumPhotoGroupsForWebGallery,
} from '../../graphql/queries/album';
import { MeQuery } from '../../../../graphql/queries/account';
import withCTAProps from '../ShutterbugCTAOnboardingModal';
import withHierarchyViewsCreate from '../../../../components/global/HiearchyGroups/hoc/withHierarchyViewsCreate';

const withAlbum = graphql(AlbumForWebGalleries, {
  options: ({ match }) => ({
    variables: {
      id: match.params.albumId,
    },
  }),
  props: ({ data: { loading, album } }) => ({
    loading,
    album,
  }),
});

const withAlbumPhotos = graphql(AlbumForWebGalleriesPhotos, {
  options: ({ match }) => ({
    variables: {
      id: match.params.albumId,
      ignore_watermark: true,
      limit: 100,
      offset: 0,
      for_web_gallery: true,
    },
  }),
  props: ({ data: { album, fetchMore } }) => ({
    photosUngrouped: album && album.photos_ungrouped,
    loadMoreUngroupedPhotos() {
      return fetchMore({
        variables: {
          offset: album.photos_ungrouped.records.length,
        },
        updateQuery: (previousResult, { fetchMoreResult }) => {
          if (!fetchMoreResult) {
            return previousResult;
          }

          return {
            ...previousResult,
            album: {
              ...previousResult.album,
              photos_ungrouped: {
                ...previousResult.album.photos_ungrouped,
                records: [
                  ...previousResult.album.photos_ungrouped.records,
                  ...fetchMoreResult.album.photos_ungrouped.records,
                ],
              },
            },
          };
        },
      });
    },
  }),
});

const withAlbumPhotoGroups = graphql(AlbumPhotoGroupsForWebGallery, {
  options: ({ match }) => ({
    variables: {
      id: match.params.albumId,
      ignore_watermark: true,
      limit: 999,
      offset: 0,
    },
  }),
  props: ({ data: { loading, album } }) => ({
    loadingPhotoGroups: loading,
    photoGroups: album && album.album_photo_groups.records,
  }),
  // Just to avoid fetching everything at once.
  skip: ({ album }) => !album,
});

const withUserData = graphql(MeQuery, {
  props: ({ data }) => ({
    user: data.me,
  }),
  skip: ({ authenticated }) => !authenticated,
});

const mapStateToProps = ({ auth }) => ({
  authenticated: auth.authenticated,
});

export default compose(
  withRouter,
  connect(mapStateToProps),
  withAlbum,
  withAlbumPhotos,
  withAlbumPhotoGroups,
  withHierarchyViewsCreate(({ match }) => match.params.albumId),
  withUserData,
  withCTAProps,
)(WebGalleryAlbum);
